module.exports = __webpack_public_path__ + "img/logo.0bf9d96c.png";